export const BREADCRUMB_CHEVRON_LENGTH = 22;
export const BREADCRUMB_THRESHOLD_COEFFICIENT = 0.66;
